import { WebappApiResponse } from '@/lib/types/request/request';
import Employee from '@/modules/people/types/employee';
import { get } from '@webapp-next/lib/request/webapp/http';

interface Params {
  employeeId: number;
  effectiveDate?: string;
}
export default async function employeeGetWithFilters({
  employeeId,
  effectiveDate,
}: Params): Promise<WebappApiResponse<Employee, Record<string, unknown>>> {
  try {
    const { data } = await get(
      `api/v1/supervise/employee/${employeeId}${
        effectiveDate
          ? `?effectiveDate=${encodeURIComponent(effectiveDate)}`
          : ''
      }`
    );

    return {
      success: true,
      message: '',
      data: data || {},
    };
  } catch (e) {
    console.error(e);
    throw e;
  }
}
